import { render, staticRenderFns } from "./AuthButton.vue?vue&type=template&id=2a5e6352&"
import script from "./AuthButton.vue?vue&type=script&lang=ts&"
export * from "./AuthButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports